import {IncidentState} from '../constants'

export const checkIfDisabled = (state_id: number) => {
  return (
    state_id === IncidentState.Closed || state_id === IncidentState.Cancelled
  )
}
